/*
 * Sticky köpfält på mobil.
 *
 * Visas när den vanliga köpknappen scrollats ur bild, döljs när den syns igen.
 * IntersectionObserver används i stället för scroll-lyssnare för att slippa
 * layout-läsningar på varje scroll-event.
 *
 * Variantnamn och pris speglas från Dawns egen variantlogik — ingen egen
 * variantmatchning här.
 */

class SsStickyAtc extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-ss-sticky-action]');
    this.variantEl = this.querySelector('[data-ss-sticky-variant]');
    this.priceEl = this.querySelector('[data-ss-sticky-price]');

    this.productInfo = document.querySelector('product-info');
    this.form = this.productInfo?.querySelector('form[data-type="add-to-cart-form"]');
    this.realSubmit = this.form?.querySelector('[name="add"]');
    this.picker = this.productInfo?.querySelector('variant-selects');

    if (!this.realSubmit) return;

    this.observe();
    this.button?.addEventListener('click', () => this.jumpToChoice());

    // Dawn skickar detta när en variant byts.
    document.addEventListener('variant:change', (event) => this.sync(event));
    this.picker?.addEventListener('change', () => {
      // Vänta in Dawns egen uppdatering innan vi läser av den.
      requestAnimationFrame(() => this.syncFromDom());
    });
  }

  observe() {
    if (!('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.hidden = entry.isIntersecting;
      },
      { rootMargin: '0px 0px -40px 0px' }
    );
    this.observer.observe(this.realSubmit);
  }

  jumpToChoice() {
    const target = this.productInfo?.querySelector('[data-ss-size-option]') || this.realSubmit;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // Ge fokus till första valbara knappen så tangentbord och skärmläsare följer med.
    const firstOption = target.querySelector?.('input[type="radio"]');
    window.setTimeout(() => (firstOption || this.realSubmit).focus({ preventScroll: true }), 400);
  }

  sync(event) {
    const variant = event?.detail?.variant;
    if (!variant) return;
    if (this.variantEl) this.variantEl.textContent = variant.title;
    if (this.priceEl && variant.price != null) {
      this.priceEl.textContent = this.formatMoney(variant.price);
    }
    this.refreshButton(true);
  }

  syncFromDom() {
    const chosen = this.productInfo?.querySelector('[data-ss-size-option] input:checked');
    this.refreshButton(Boolean(chosen));
    const priceNow = this.productInfo?.querySelector('.price-item--regular, .price-item--sale');
    if (chosen && this.variantEl) this.variantEl.textContent = chosen.value;
    if (priceNow && this.priceEl) this.priceEl.textContent = priceNow.textContent.trim();
  }

  refreshButton(hasChoice) {
    if (!this.button) return;
    if (hasChoice) {
      this.button.textContent = this.realSubmit.textContent.trim() || 'Lägg i varukorg';
      this.button.dataset.ssReady = 'true';
      this.button.onclick = () => this.realSubmit.click();
    }
  }

  formatMoney(cents) {
    const amount = (cents / 100).toLocaleString('sv-SE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return `${amount} kr`;
  }
}

if (!customElements.get('ss-sticky-atc')) {
  customElements.define('ss-sticky-atc', SsStickyAtc);
}
